<script setup lang="ts">
import "vue3-toastify/dist/index.css";
import { RouterView, useRoute } from "vue-router";
import { URLs } from "./constants";
import { computed, onMounted } from "vue";
import { useCustomerStore } from "./stores/customer";
import Loading from "./components/Widgets/Loading.vue";
import { useAuthStore } from "./stores/auth";

const customerStore = useCustomerStore();
import { useGlobalStore } from "@/stores/global";
import Auth from "./utils/auth";

const authStore = useAuthStore();
const user = computed(() => authStore.user);
const isCustomersListLoading = computed(() => customerStore.isCustomersListLoading);

const globalStore = useGlobalStore();
const route = useRoute();

onMounted(async () => {
  await globalStore.fetchContents();
});
</script>

<template>
  <v-app id="thor-ai">
    <v-main v-if="route.name === 'home'" class="page-home">
      <Loading v-if="isCustomersListLoading" message="Loading customers..." />
      <RouterView v-else />
    </v-main>
    <v-main class="page-main" v-else>
      <v-app-bar>
        <v-app-bar-title>
          <RouterLink to="/"><img src="/logo.png" style="height: 15px" /></RouterLink>
        </v-app-bar-title>
        <v-spacer></v-spacer>
        <v-menu v-if="user" location="bottom right">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" variant="text" class="d-flex align-center">
              <v-icon start>mdi-account</v-icon>
              <span class="ml-1 mr-1">{{ user?.name || "User" }}</span>
              <v-icon size="18">mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-subheader class="text-caption">Account</v-list-subheader>
            <v-list-item :to="URLs.PAGE_PROFILE">
              <v-list-item-title>Profile</v-list-item-title>
            </v-list-item>
            <v-list-item @click="authStore.logout">
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>

            <v-divider class="my-1" />

            <v-list-subheader class="text-caption">Management</v-list-subheader>
            <v-list-item
              v-if="authStore.hasPermission(Auth.Permission.CUSTOMER_LIST)"
              :to="URLs.PAGE_CUSTOMER_LIST"
            >
              <v-list-item-title>Customers</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="authStore.hasPermission(Auth.Permission.REPORT_LIST)"
              :to="URLs.PAGE_REPORT_LIST"
            >
              <v-list-item-title>Reports</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="authStore.hasPermission(Auth.Permission.REPORT_LIST)"
              :to="URLs.PAGE_USAGE_DASHBOARD"
            >
              <v-list-item-title>Usage</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="authStore.hasPermission(Auth.Permission.CONTENT_UPSERT)"
              :to="URLs.ADMIN.PAGE_PRIVACY_POLICY_EDIT"
            >
              <v-list-item-title>Edit Privacy Policy</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="authStore.hasPermission(Auth.Permission.CONTENT_UPSERT)"
              :to="URLs.ADMIN.PAGE_TERMS_OF_SERVICE_EDIT"
            >
              <v-list-item-title>Edit Terms of Service</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="authStore.hasPermission(Auth.Permission.REPORT_PROMPT_UPDATE)"
              :to="URLs.ADMIN.PAGE_REPORT_PROMPT_EDIT"
            >
              <v-list-item-title>Edit Default Prompt</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <Loading v-if="isCustomersListLoading" message="Loading customers..." />
      <RouterView v-else />
    </v-main>
    <v-footer height="30" v-if="route.name !== 'home'">
      <v-row>
        <v-col align="right">
          <RouterLink :to="URLs.PAGE_PRIVACY" class="mr-2">Privacy Policy</RouterLink>
          <RouterLink :to="URLs.PAGE_TERMS">Terms of Service</RouterLink>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>
<style scoped>
footer {
  max-height: 30px;
}
</style>
